import { config } from '../config/config';
import { postJson } from '../ap/utils/fetchService';

export type OrderFile = {
  fileName: string;
  documentType: string;
  fileId: string;
  fileUploadUrl?: string;
}

export interface CreateOrderQuery {
  firstName: string;
  middleNames: string;
  lastName: string;
  dateOfBirth: string,
  phoneNumber: string;
  email: string;
  addressLine1: string;
  addressLine2?: string;
  suburb: string;
  state: string;
  postcode: string;
  dpid: string;
  transactedAddress: string;
  referenceId: string;
  category: string;
  orderFiles: Array<OrderFile>;
}

interface CreateOrderResponse {
  ptOrderId: string;
  orderStatus: string;
  firstName: string;
  middleNames: string;
  lastName: string;
  dateOfBirth: string,
  phoneNumber: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postcode: string;
  dpid: string;
  transactedAddress: string;
  referenceId: string;
  clmId: string;
  createdBy: string;
  securepayAccessToken: string,
  securepayCustomerId: string,
  orderFiles: Array<OrderFile>;
}

export const createOrder = (query: CreateOrderQuery): Promise<CreateOrderResponse> => {
  return postJson<CreateOrderResponse>({
    url: config.ordersConfig.ordersEndpoint,
    headers: {},
    body: query
  });
}

